/**
 * OFEmptyState - Componente para estado vazio de OFs
 * Extraído de GestaoOFs.js para melhor modularidade
 */
import React from 'react';
import { Card } from '../../ui/card';
import { FileText } from 'lucide-react';

export default function OFEmptyState({ message = 'Nenhuma OF encontrada' }) {
  return (
    <Card className="p-12 text-center" data-testid="of-empty-state">
      <FileText className="h-16 w-16 mx-auto text-stone-300 mb-4" />
      <p className="text-stone-500">{message}</p>
    </Card>
  );
}
